import { Dialog } from "@headlessui/react";
import { v4 as uuidv4 } from "uuid";
import { useForm } from "react-hook-form";
import { sendEmailNotification } from "service/notificationservice/sendEmailNotification";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation, Trans } from "react-i18next";

import FormInputError from "components/General/FormInputError";
import GeneralPurposeDialog from "components/General/GeneralPurposeDialog";

import EverlakeLoadingOverlay from "components/General/EverlakeLoadingOverlay";
const AgentAssistantReminderModel = ({
  openAssistantModel,
  setopenAssistantModel,
  assistantfname,
  assistantlname,
  assistantemailId,
}) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useSelector((s) => s.user);
  const noteId = uuidv4();
  const [message, setMessage] = useState(
    t("AgentAssistantReminderModel-Reminder-Desc")
  );
  const [openDialog, setOpenDialog] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors: sendReminderErrors },
  } = useForm({
    defaultValues: {},
  });
  useEffect(() => {
    reset();
  }, []);
  async function onSubmit(data) {
    setIsLoading(true);
    await sendEmailNotification(assistantemailId, 14, {
      username: assistantfname,
      registerlink: `accounttype=agent-administrative-assistant&userid=${user.userId}`,
    }).catch((error) => {
      setIsLoading(false);
      setMessage(t("AgentAssistantReminderModel-Error-Desc"));
      setOpenDialog(true);
      setopenAssistantModel(false);
      console.log(error);
    });
    reset();
    setOpenDialog(true);
    setopenAssistantModel(false);
    setIsLoading(false);
  }
  function closeForm() {
    reset();
    setopenAssistantModel(false);
  }

  return (
    <>
      <Dialog
        open={openAssistantModel}
        onClose={() => closeForm()}
        className="ui-dialogs"
      >
        {/* The backdrop, rendered as a fixed sibling to the panel container */}
        <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
        {/* Full-screen container to center the panel */}
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Dialog.Panel
            role="dialog"
            aria-modal="true"
            className="ui-default-dialog"
          >
            <Dialog.Title className="font-body text-xl font-bold text-left">
              {t("AgentAssistantReminderModel-dialogTitle")}
            </Dialog.Title>
            <button
              className="ui-default-dialog-close"
              aria-label={t(
                "AgentAssistantReminderModel-dialog-buttonAriaLabel"
              )}
              onClick={() => closeForm()}
            >
              <svg
                className="ui-icon h-3.5 w-3.5"
                focusable="false"
                aria-hidden="true"
                role="presentation"
              >
                <use href="#ui-icon-close"></use>
              </svg>
            </button>
            <Dialog.Description>
              {t("AgentAssistantReminderModel-dialogDescription")}
            </Dialog.Description>
            <EverlakeLoadingOverlay
              isLoading={isLoading}
              loadingText={t("AgentAssistantReminderModel-dialogLoadingText")}
            >
              <div className="mx-auto md:w-4/5">
                <form
                  className="grid grid-cols-1 gap-4"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <div>
                    <label forhtml={`${noteId}-email`} className="mb-1 block">
                      {t("AgentAssistantReminderModel-emailLabel")}
                    </label>
                    <input
                      id={`${noteId}-email`}
                      className="w-full"
                      type="text"
                      readOnly={true}
                      aria-describedby={`${noteId}-emailError`}
                      aria-labelledby={t(
                        "AgentAssistantReminderModel-emailAriaLabel"
                      )}
                      defaultValue={assistantemailId}
                      {...register("email", {
                        required: t(
                          "AgentAssistantReminderModel-EmailRequired"
                        ),
                        pattern: {
                          value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                          message: t(
                            "AgentAssistantReminderModel-emailRequiredMessage"
                          ),
                        },
                      })}
                    />
                    {sendReminderErrors.email && (
                      <FormInputError
                        id={`${noteId}-emailError`}
                        errorMessage={sendReminderErrors.email.message}
                      />
                    )}
                  </div>

                  <label forhtml={`${noteId}-note`} className="mb-1 block">
                    {t("AgentAssistantReminderModel-incorrectEmailMessage")}
                  </label>
                  {/* <div>
                  <textarea
                    id={`${noteId}-note`}
                    type="text"
                    rows="4"
                    placeholder="Type message here..."
                    {...register(`note`)}
                  />
                  {sendReminderErrors.note && (
                    <FormInputError
                      id={`${noteId}-note`}
                      errorMessage={sendReminderErrors.note.message}
                    />
                  )}
                </div> */}
                  <div className="block text-right">
                    <button
                      className="ui-btn-secondary ui-btn-min-w mt-4"
                      onClick={() => closeForm()}
                    >
                      <Trans
                        i18nKey="AgentAssistantReminderModel-cancelButton"
                        components={{
                          span: <span className="sr-only" />,
                        }}
                      />
                    </button>
                    <button className="ui-btn-primary ui-btn-min-w mt-4">
                      <Trans
                        i18nKey="AgentAssistantReminderModel-sendButton"
                        components={{
                          span: <span className="sr-only" />,
                        }}
                      />
                    </button>
                  </div>
                </form>
              </div>
            </EverlakeLoadingOverlay>
          </Dialog.Panel>
        </div>
      </Dialog>
      <GeneralPurposeDialog
        state={openDialog}
        setState={setOpenDialog}
        title={t("AgentAssistantReminderModel-generalPurposeDialog-title")}
        desc={message}
      />
    </>
  );
};

export default AgentAssistantReminderModel;
